import { render, staticRenderFns } from "./Single-Contract-Detail.vue?vue&type=template&id=5528f44c&"
import script from "./Single-Contract-Detail.vue?vue&type=script&lang=js&"
export * from "./Single-Contract-Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports